import { useLanguage } from '../../context/LanguageContext';

export function AboutContent({ about }) {
  const { language, translate } = useLanguage();
  const isRTL = language === "ar";

  // Helper to safely get value
  const getValue = (field, fallback = '') => {
    if (!field) return fallback;
    if (typeof field === 'string') return field;
    if (field && typeof field === 'object' && 'value' in field) {
      return field.value ?? fallback;
    }
    return fallback;
  };

  const getParagraphs = (html = '') => {
    if (!html) return ['', ''];

    const tempDiv = document.createElement('div');
    tempDiv.innerHTML = html;
    const paragraphs = Array.from(tempDiv.querySelectorAll('p'))
      .map(p => p.textContent?.trim())
      .filter(Boolean);

    return [
      paragraphs[0] || translate('newAbout.content.para1') || '',
      paragraphs[1] || translate('newAbout.content.para2') || ''
    ];
  };

  const title = getValue(about?.title, translate('newAbout.content.title'));
  const imageUrl = getValue(about?.imageUrl, '/aboutcar.png');
  const rawDescription = getValue(about?.description, '');
  const [para1] = getParagraphs(rawDescription);

  return (
    <section
      className="bg-bg-medium py-16 sm:py-24 lg:py-32"
      dir={isRTL ? "rtl" : "ltr"}
      lang={language}
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid lg:grid-cols-2 gap-12 lg:gap-16 items-center">
          <div>
            <p className="text-blue-500 text-xs sm:text-sm font-semibold tracking-wide mb-4">
              {translate('newAbout.content.mission')}
            </p>

            <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-white mb-6 leading-tight">
              {title}
            </h2>

            {para1 && (
              <p className="text-gray-400 text-base sm:text-lg leading-relaxed mb-6">
                {para1}
              </p>
            )}

            <a
              href="#"
              className="text-blue-500 hover:text-blue-400 font-semibold text-sm sm:text-base inline-flex items-center gap-2 transition-colors"
            >
              {translate('newAbout.content.readMore')}
              <span>→</span>
            </a>
          </div>

          <div className="relative h-80 sm:h-96 lg:h-full rounded-lg overflow-hidden">
            <img
              src={imageUrl}
              alt="About us"
              className="w-full h-full object-cover rounded-lg"
              onError={(e) => {
                e.currentTarget.src = '/aboutcar.png';
              }}
            />
          </div>
        </div>
      </div>
    </section>
  );
}